import { ActionType, type Action } from '@/models/HistoryModel';

/** One history entry, with rollback if a later member fails. */
export function combineActions(actions: Action[], description: string): Action {
  let applied = 0;
  return {
    type: ActionType.AddTiles,
    description,
    do() {
      applied = 0;
      try {
        for (const action of actions) {
          applied++;
          action.do();
        }
      } catch (error) {
        try {
          for (let i = applied - 1; i >= 0; i--) actions[i].undo();
        } finally {
          applied = 0;
        }
        throw error;
      }
    },
    undo() {
      try {
        for (let i = applied - 1; i >= 0; i--) actions[i].undo();
      } finally {
        applied = 0;
      }
    },
  };
}
